import clsx from "clsx";
// icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHashtag } from "@fortawesome/pro-solid-svg-icons";
import Link from "next/link";

export function TagS({ children, className, ...props }) {
  return (
    <p
      className={
        (clsx(className),
        "border-0 flex w-fit whitespace-nowrap items-center gap-1 text-icn text-xs font-bold leading-none ")
      }
      {...props}
    >
      <FontAwesomeIcon icon={faHashtag} />
      {children}
    </p>
  );
}
